// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1_AL3","range":"MonthRangeSwitch_range__19J-f","disabled":"MonthRangeSwitch_disabled__3Cxnw"};